<template>
  <div class="card card-custom gutter-b">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label">
          Job Listing
          <span class="d-block text-muted pt-2 font-size-sm">
            Showing latest six month of records
          </span>
        </h3>
      </div>
    </div>
    <div class="card-body">
      <div class="mb-7">
        <div class="row align-items-center">
          <div class="col-lg-9 col-xl-8">
            <div class="row align-items-center">
              <div class="col-md-3 my-2 my-md-0">
                <div class="d-flex align-items-center">
                  <label class="mr-3 mb-0">
                    Search Date
                  </label>
                  <div class="input-icon">
                    <input v-model="fromSearchDate" type="date" class="form-control" id="kt_datatable_search_query" />
                    <span>
                      <i class="flaticon2-calendar-1 text-muted"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-3 my-2 my-md-0">
                <div class="d-flex align-items-center">
                  <label class="mr-3 mb-0">Till</label>
                  <div class="input-icon">
                    <input v-model="toSearchDate" type="date" class="form-control" id="kt_datatable_search_query" />
                    <span>
                      <i class="flaticon2-calendar-1 text-muted"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-3 my-2 my-md-0">
                <submit-button
                  type="button"
                  :loading="loading"
                  text="Search"
                  @button-click="
                    searchJobWithinDate(fromSearchDate, toSearchDate);
                    loading = true;
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <v-client-table :columns="columns" v-model="list" :options="options">
        <template slot="id" slot-scope="props">
          {{ props.row.id }}
          <button class="btn btn-icon btn-xs btn-light-primary" @click="openJobDetail(props.row.id)">
            <i class="ki ki-info"></i>
          </button>
          <job-dropdown class="close" :id="props.row.id" />
        </template>

        <div slot="no" slot-scope="props">
          <tr v-for="(a, index) in props.row.trips" :key="index">
            <td class="nested-td-no-border">{{ a.type }}</td>
          </tr>
        </div>

        <template slot="address" slot-scope="props">
          <tr v-for="(a, index) in props.row.trips" :key="index">
            <td class="nested-td-no-border">{{ a.address }}</td>
          </tr>
        </template>

        <div slot="date" slot-scope="props">
          <tr v-for="(a, index) in props.row.trips" :key="index">
            <td class="nested-td-no-border">{{ a.date }} {{ a.from_time }} - {{ a.to_time }}</td>
          </tr>
        </div>

        <div slot="trip_status" slot-scope="props">
          <tr v-for="(a, index) in props.row.trips" :key="index">
            <td class="nested-td-no-border">
              <span class="label label-inline label-light-success font-weight-bold">
                {{ a.status }}
              </span>
            </td>
          </tr>
        </div>

        <div slot="action">
          <b-dropdown
            size="sm"
            variant="link"
            toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
            no-caret
            right
            no-flip
          >
            <template v-slot:button-content>
              <i class="ki ki-bold-more-ver"></i>
            </template>
            <div class="navi navi-hover min-w-md-250px">
              <b-dropdown-text tag="div" class="navi-item">
                <a href="#" class="navi-link">
                  <span class="navi-icon"><i class="fas fa-qrcode"></i></span>
                  <span class="navi-text">Print QR label</span>
                </a>
              </b-dropdown-text>
            </div>
          </b-dropdown>
        </div>
      </v-client-table>
    </div>

    <job-full-details ref="modal" :jobid="jobid" />
  </div>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";
import { Event } from "vue-tables-2";
import { formatISO, subMonths } from "date-fns";

import { listJobWithinDate } from "@/api/client-operation.api";
import SubmitButton from "@/components/button/SubmitButton";
import JobFullDetails from "@/components/general/JobFullDetails";
import JobDropdown from "@/components/general/JobDropdown";

export default {
  name: "ListJob",
  components: { SubmitButton, JobFullDetails, JobDropdown },
  setup(_, { root }) {
    const fromSearchDate = ref(formatISO(subMonths(new Date(), 6), { representation: "date" }));
    const toSearchDate = ref(formatISO(new Date(), { representation: "date" }));
    const loading = ref(false);
    const list = ref([]);
    const modal = ref(null);

    onMounted(() => {
      searchJobWithinDate(fromSearchDate.value, toSearchDate.value);
    });

    const searchJobWithinDate = async (from, to) => {
      const response = await listJobWithinDate({ from, to });
      list.value = response.data;
      loading.value = false;
    };

    const columns = ["id", "status", "no", "address", "date", "trip_status", "action"];
    const options = {
      headings: {
        id: "Job No.",
        status: "Status",
        no: "Trip #",
        address: "Address",
        date: "Date",
        trip_status: "Status",
        action: ""
      },
      skin: "b-table table table-bordered",
      tabbable: false,
      filterable: false,
      sortable: [],
      customFilters: [
        {
          name: "alphabet",
          callback: function(row, query) {
            return row.jobNo == query;
          }
        }
      ]
    };

    function filter() {
      Event.$emit("vue-tables.filter::alphabet", "858392983");
    }

    const jobid = ref();
    const openJobDetail = job => {
      jobid.value = job;
      root.$nextTick(() => modal.value.$refs["jobdetails"].show());
    };

    return {
      fromSearchDate,
      toSearchDate,
      columns,
      options,
      filter,
      list,
      searchJobWithinDate,
      openJobDetail,
      loading,
      modal,
      jobid
    };
  }
};
</script>

<style scoped>
.nested-td-no-border {
  border: none;
}
</style>
